module.exports = __webpack_public_path__ + "static/media/callingsetup.b4e90d89.png";